var _defs, _line, _line2, _line3, _line4, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle5, _circle6, _circle7, _circle8, _path11, _path12, _path13, _path14, _circle9, _circle0, _circle1, _circle10, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _circle11, _circle12, _circle13, _circle14, _path27, _path28, _path29, _path30, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect, _rect2, _path39, _path40, _path41, _path42, _rect3, _rect4, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _polygon, _polygon2, _polygon3, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _polygon4, _polygon5, _polygon6, _polygon7, _path57, _polygon8, _polygon9, _polygon0, _rect5, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _ellipse, _ellipse2, _path68, _ellipse3, _line5, _path69, _path70, _polygon1, _path71, _path72, _path73, _path74, _polyline, _line6, _line7, _path75, _path76, _polygon10, _path77, _g, _path78, _path79, _polygon11, _polygon12, _polygon13, _polyline2, _path80, _path81, _polygon14, _path82, _path83, _path84, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polyline3, _polygon23, _polygon24, _line8, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polyline4, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _line9, _path106, _path107, _path108, _path109, _path110, _path111, _circle31, _circle32, _path112, _path113, _path114, _path115, _polygon31, _path116, _polygon32, _path117, _path118, _path119;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScene3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 443.52 384.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-11.29 -16.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.87,143.69l-11.11-1.15h0a4.52,4.52,0,0,0-5.29-1.89l-3,1a4.52,4.52,0,0,0-3,4.81l.12,1-4.26,4.18a3.75,3.75,0,0,0-.58,4.62h0l-1.24,1.93a7.13,7.13,0,0,0-.45,6.9l2.41,5.11a5.84,5.84,0,0,0,6.6,3.21l26-6Z",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 412.56,
    y1: 373.18,
    x2: 426.64,
    y2: 373.18,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 225.71,
    y1: 373.18,
    x2: 403.75,
    y2: 373.18,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24.13,
    y1: 373.18,
    x2: 173.63,
    y2: 373.18,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 8.58,
    y1: 373.18,
    x2: 16.68,
    y2: 373.18,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.85,
    cy: 181.84,
    r: 3.96,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.18,
    cy: 181.84,
    r: 3.96,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 181.84,
    r: 3.96,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.83,
    cy: 181.84,
    r: 3.96,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.41,198.5a4,4,0,1,1-4-4A4,4,0,0,1,102.41,198.5Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74,198.5a4,4,0,1,1-4-4A4,4,0,0,1,122.74,198.5Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06,198.5a4,4,0,1,1-4-4A4,4,0,0,1,143.06,198.5Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,198.5a4,4,0,1,1-4-4A4,4,0,0,1,163.39,198.5Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.11,212.19a4,4,0,1,1-4-4A4,4,0,0,1,21.11,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.43,212.19a4,4,0,1,1-4-4A4,4,0,0,1,41.43,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.76,212.19a4,4,0,1,1-4-4A4,4,0,0,1,61.76,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M82.09,212.19a4,4,0,1,1-4-4A4,4,0,0,1,82.09,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.41,212.19a4,4,0,1,1-4-4A4,4,0,0,1,102.41,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74,212.19a4,4,0,1,1-4-4A4,4,0,0,1,122.74,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06,212.19a4,4,0,1,1-4-4A4,4,0,0,1,143.06,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,212.19a4,4,0,1,1-4-4A4,4,0,0,1,163.39,212.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.85,
    cy: 209.23,
    r: 3.96,
    fill: "#fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.18,
    cy: 209.23,
    r: 3.96,
    fill: "#fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 209.23,
    r: 3.96,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.83,
    cy: 209.23,
    r: 3.96,
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.41,225.89a4,4,0,1,1-4-4A4,4,0,0,1,102.41,225.89Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74,225.89a4,4,0,1,1-4-4A4,4,0,0,1,122.74,225.89Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06,225.89a4,4,0,1,1-4-4A4,4,0,0,1,143.06,225.89Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,225.89a4,4,0,1,1-4-4A4,4,0,0,1,163.39,225.89Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.85,
    cy: 222.93,
    r: 3.96,
    fill: "#fff"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.18,
    cy: 222.93,
    r: 3.96,
    fill: "#fff"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 222.93,
    r: 3.96,
    fill: "#fff"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.83,
    cy: 222.93,
    r: 3.96,
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.41,239.59a4,4,0,1,1-4-4A4,4,0,0,1,102.41,239.59Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74,239.59a4,4,0,1,1-4-4A4,4,0,0,1,122.74,239.59Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06,239.59a4,4,0,1,1-4-4A4,4,0,0,1,143.06,239.59Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,239.59a4,4,0,1,1-4-4A4,4,0,0,1,163.39,239.59Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M21.11,253.29a4,4,0,1,1-4-4A4,4,0,0,1,21.11,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.43,253.29a4,4,0,1,1-4-4A4,4,0,0,1,41.43,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.76,253.29a4,4,0,1,1-4-4A4,4,0,0,1,61.76,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.09,253.29a4,4,0,1,1-4-4A4,4,0,0,1,82.09,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M102.41,253.29a4,4,0,1,1-4-4A4,4,0,0,1,102.41,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74,253.29a4,4,0,1,1-4-4A4,4,0,0,1,122.74,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06,253.29a4,4,0,1,1-4-4A4,4,0,0,1,143.06,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,253.29a4,4,0,1,1-4-4A4,4,0,0,1,163.39,253.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.85,
    cy: 250.33,
    r: 3.96,
    fill: "#fff"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.18,
    cy: 250.33,
    r: 3.96,
    fill: "#fff"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 250.33,
    r: 3.96,
    fill: "#fff"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.83,
    cy: 250.33,
    r: 3.96,
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.41,267a4,4,0,1,1-4-4A4,4,0,0,1,102.41,267Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.74,267a4,4,0,1,1-4-4A4,4,0,0,1,122.74,267Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.06,267a4,4,0,1,1-4-4A4,4,0,0,1,143.06,267Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M163.39,267a4,4,0,1,1-4-4A4,4,0,0,1,163.39,267Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 128.54,
    r: 3.96,
    fill: "#fff"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 148.87,
    r: 3.96,
    fill: "#fff"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 169.2,
    r: 3.96,
    fill: "#fff"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 189.52,
    r: 3.96,
    fill: "#fff"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 209.85,
    r: 3.96,
    fill: "#fff"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 230.17,
    r: 3.96,
    fill: "#fff"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 250.5,
    r: 3.96,
    fill: "#fff"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.98,
    cy: 270.83,
    r: 3.96,
    fill: "#fff"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 128.54,
    r: 3.96,
    fill: "#fff"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 148.87,
    r: 3.96,
    fill: "#fff"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 169.2,
    r: 3.96,
    fill: "#fff"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 189.52,
    r: 3.96,
    fill: "#fff"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 209.85,
    r: 3.96,
    fill: "#fff"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 230.17,
    r: 3.96,
    fill: "#fff"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 250.5,
    r: 3.96,
    fill: "#fff"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.29,
    cy: 270.83,
    r: 3.96,
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,149.16a4,4,0,1,1,4-4A4,4,0,0,1,385.88,149.16Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,169.49a4,4,0,1,1,4-4A4,4,0,0,1,385.88,169.49Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,189.82a4,4,0,1,1,4-4A4,4,0,0,1,385.88,189.82Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,210.14a4,4,0,1,1,4-4A4,4,0,0,1,385.88,210.14Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,230.47a4,4,0,1,1,4-4A4,4,0,0,1,385.88,230.47Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,250.79a4,4,0,1,1,4-4A4,4,0,0,1,385.88,250.79Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,271.12a4,4,0,1,1,4-4A4,4,0,0,1,385.88,271.12Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M385.88,291.45a4,4,0,1,1,4-4A4,4,0,0,1,385.88,291.45Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 203.78,
    y: 56.91,
    width: 151.95,
    height: 327.52,
    rx: 18.12,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 195.8,
    y: 56.91,
    width: 151.95,
    height: 327.52,
    rx: 18.12,
    fill: "#bfcad3"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M343.32,77.15V397.51a25,25,0,0,1-12.92,3.58H212.85a25.17,25.17,0,0,1-25.19-25.19V98.75a25.17,25.17,0,0,1,25.19-25.17H330.4A25,25,0,0,1,343.32,77.15Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#bfcad3"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 241.57,
    y1: 61.77,
    x2: 276.72,
    y2: 61.77,
    fill: "none",
    stroke: "#4c6e91",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M343.33,88.5v293a27.57,27.57,0,0,1-15.49,4.73H215.41a27.75,27.75,0,0,1-27.74-27.75V111.52a27.7,27.7,0,0,1,27.74-27.74H327.84A27.48,27.48,0,0,1,343.33,88.5Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201,382.15v16a25.13,25.13,0,0,1-13.33-22.21V358.44A27.7,27.7,0,0,0,201,382.15Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#4c6e91",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,76.53V87.8a27.73,27.73,0,0,0-13.33,23.72V98.75A25.15,25.15,0,0,1,201,76.53Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#4c6e91",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201,87.8V382.15a27.7,27.7,0,0,1-13.33-23.71V111.52A27.73,27.73,0,0,1,201,87.8Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5f5f5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M355.57,111.53V358.45a27.75,27.75,0,0,1-12.25,23v-293A27.72,27.72,0,0,1,355.57,111.53Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 350.76,
    y: 117.58,
    width: 6.63,
    height: 105.12,
    rx: 2.95,
    fill: "#bfcad3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 350.76,
    y: 235.89,
    width: 6.63,
    height: 21.06,
    rx: 2.95,
    fill: "#bfcad3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M367.47,239.36h0c1.16,0,2.1-1.69,2.1-3.77V138c0-2.09-.94-3.77-2.1-3.77h0c-1.16,0-2.1,1.68-2.1,3.77v97.58C365.37,237.67,366.31,239.36,367.47,239.36Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M367.47,273.61h0c1.16,0,2.1-1.69,2.1-3.77V256.32c0-2.08-.94-3.77-2.1-3.77h0c-1.16,0-2.1,1.69-2.1,3.77v13.52C365.37,271.92,366.31,273.61,367.47,273.61Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M324,147.13a5.43,5.43,0,0,0,.09.56,7.61,7.61,0,0,0,9,5.94l120.13-24.44,1.66,8.13L334.11,161.88a15.8,15.8,0,0,1-11.26-1.9,7.92,7.92,0,0,1-.69-.42,15.94,15.94,0,0,1-6.81-10.1,5.48,5.48,0,0,1-.1-.56q-.09-.54-.15-1.08a15.64,15.64,0,0,1,.56-6h0a15.9,15.9,0,0,1,12.1-11.16l120.71-24.56,1.65,8.12L330,138.71A7.61,7.61,0,0,0,323.9,146,6.82,6.82,0,0,0,324,147.13Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ff6665"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M445.55,115.19l3,14.92L333,153.63a7.62,7.62,0,0,1-3-14.93Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M311.43,149.71c0,.18.05.35.08.53a7.59,7.59,0,0,0,9,5.94l49.45-10.06,1.65,8.13-50,10.18a15.91,15.91,0,1,1-6.34-31.18l50-10.18,1.65,8.12-49.44,10.07-.51.12-.25.07a2.6,2.6,0,0,0-.36.13,3.47,3.47,0,0,0-.5.2l-.18.08h0a7.6,7.6,0,0,0-1.84,1.26l-.21.21a7.53,7.53,0,0,0-.92,1.11c-.1.15-.2.31-.29.47a6,6,0,0,0-.3.56h0a4.35,4.35,0,0,0-.25.59,4.69,4.69,0,0,0-.2.6c-.05.19-.1.37-.13.54l0,.19a3.35,3.35,0,0,0-.08.54h0a4.49,4.49,0,0,0,0,.64c0,.16,0,.33,0,.49a4,4,0,0,0,.05.6Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#da5565"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M362.32,132.13l3,14.92-44.87,9.13a7.61,7.61,0,0,1-9-5.94,5.43,5.43,0,0,1-.09-.56,8.14,8.14,0,0,1-.06-1.09,7.61,7.61,0,0,1,6.1-7.33Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M366.08,137.45l.21,1.06-54.87,11.17a8.14,8.14,0,0,1-.06-1.09Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#4c6e91",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M446.74,121l.22,1.06L363.73,139a8.2,8.2,0,0,1-.06-1.1Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ebebeb"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "322.83 136.75 323.55 145.07 311.9 147.44 311.55 143.32 311.19 139.12 322.83 136.75",
    fill: "#2b2b2b"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "322.04 127.46 322.13 128.54 322.83 136.75 311.19 139.12 310.49 130.91 310.4 129.83 322.04 127.46",
    fill: "#2b2b2b"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.18 146.31 314.58 140.84 319.83 143.94 322.04 127.46 310.4 129.83 308.18 146.31",
    fill: "#ceb388"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M159.44,332.15l-2,10.57a6.93,6.93,0,0,1-8.11,5.53L55.44,330.5l-1.67,8.81,98.39,18.6a12.32,12.32,0,0,0,14.4-9.82l3.34-17.62a12.34,12.34,0,0,0-9.83-14.4l-98.39-18.6L60,306.28,153.91,324A7,7,0,0,1,159.44,332.15Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#487081"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M63.84,307l-4.58,24.22,84.78,16a12.32,12.32,0,0,0,14.4-9.82h0a12.33,12.33,0,0,0-9.82-14.4Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ebebeb"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M209.78,347.14A21.29,21.29,0,0,1,193.16,364l-.35.07a19.29,19.29,0,0,1-2.63.33,20.54,20.54,0,0,1-5.28-.33l-51.83-9.8,1.67-8.81,50.85,9.62.7.11.71.07.66,0h.16a5.66,5.66,0,0,0,.58,0c.23,0,.46,0,.69,0l.61-.08a12.13,12.13,0,0,0,1.43-.3c.21-.05.41-.12.61-.18l.09,0,.14,0c.45-.17.9-.36,1.34-.57l.17-.09c.25-.13.5-.26.74-.4s.48-.3.71-.47.44-.31.64-.47c0,0,.05,0,.06-.05.18-.14.36-.3.53-.45s.38-.35.55-.54.22-.22.32-.34.28-.31.4-.46.25-.31.37-.48A3.71,3.71,0,0,0,198,350l.15-.22c.18-.28.36-.56.51-.85a2.44,2.44,0,0,0,.14-.28,4,4,0,0,0,.29-.59c.06-.12.11-.24.16-.37l.14-.35c0-.1.07-.2.1-.3s.1-.28.14-.42.08-.27.12-.41v-.05c0-.12.06-.22.09-.34s.08-.35.11-.52a12.32,12.32,0,0,0-9.82-14.4l-50.85-9.62,1.66-8.81,51.83,9.8a21.32,21.32,0,0,1,17,24.88Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#538397"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M200,345.29a11.69,11.69,0,0,1-.3,1.2,12.3,12.3,0,0,1-14.1,8.62l-54.76-10.35,4.58-24.22,54.76,10.35a12.32,12.32,0,0,1,9.82,14.4Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.05,332.82a11.69,11.69,0,0,1-.3,1.2L61.32,320.33l.23-1.22Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#4c6e91",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M200,345.29a11.69,11.69,0,0,1-.3,1.2l-66.8-12.63.23-1.21Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ebebeb"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M191.74,354.71c-.2.06-.4.13-.61.18a12.13,12.13,0,0,1-1.43.3l-.61.08c-.23,0-.46,0-.69,0a5.66,5.66,0,0,1-.58,0h-.16l-.66,0-.71-.07-.7-.11L179.82,354l1.94-12.18,11.68,2.21Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M190.18,364.43a20.54,20.54,0,0,1-5.28-.33l-6.5-1.23,1.42-8.85,5.77,1.09.7.11.71.07.66,0h.16a5.66,5.66,0,0,0,.58,0c.23,0,.46,0,.69,0l.61-.08a12.13,12.13,0,0,0,1.43-.3c.21-.05.41-.12.61-.18Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.59 343.84 178.12 338.46 172.91 341.63 170.47 325.19 182.15 327.39 184.59 343.84",
    fill: "#ff6665"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "194.26 160.31 147.48 219.26 140.04 293.06 182.15 277.04 223.9 216.54 194.26 160.31",
    fill: "#538397"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "151.03 214.79 167.19 247.89 157.19 207.02 151.03 214.79",
    fill: "#487081"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "316.55 369.54 202.96 369.54 212.55 304.47 308.7 304.47 316.55 369.54",
    fill: "#2b2b2b"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M316.73,264.66a78.09,78.09,0,0,1-9.81,15.5l-33.25,53.06H229.08a15.86,15.86,0,0,1-15.75-14L208,275.85l-9.14-75a31.54,31.54,0,0,1,31.25-35.73h56.93A77.54,77.54,0,0,1,316.73,264.66Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#538397"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.93 143.19 215.55 173.25 255.5 162.34 253.93 139.78 218.93 143.19",
    fill: "#383334"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.66 133.04 218.93 143.19 225.77 162.34 230.18 173.15 266.52 157.33 270.66 133.04",
    fill: "#da5565"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.66 95.14 270.66 141.73 246.03 151.12 230.18 173.15 230.18 95.14 270.66 95.14",
    fill: "#edaebe"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 267.25,
    y: 103.84,
    width: 3.41,
    height: 38.56,
    fill: "#f5cad7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M272.69,112.05v17.68a29.91,29.91,0,0,1-.62,6.1,29.52,29.52,0,0,1-2.36,7,30.15,30.15,0,0,1-27.15,17c-.37,0-.73,0-1.09,0V106.64H272.2a29.15,29.15,0,0,1,.48,4.89C272.69,111.71,272.69,111.87,272.69,112.05Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#e07591"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M233,107.31c-47.94,0-31.68-59.72,15.41-41.61Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M243.89,65.38C205.7,52.64,185.59,80.8,213.2,99.2",
    transform: "translate(-11.29 -16.66)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M280.66,104.31V122a30.11,30.11,0,0,1-20.05,28.39,29.82,29.82,0,0,1-10.08,1.74c-24.33,0-30.13-7-30.13-30.13V104.31a30.18,30.18,0,0,1,2-10.79A30.84,30.84,0,0,1,229.22,83,30.14,30.14,0,0,1,279.6,96.37a30.76,30.76,0,0,1,1,7.42C280.66,104,280.66,104.14,280.66,104.31Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M262.61,121.91v17.67a29.84,29.84,0,0,1-.62,6.1,29.27,29.27,0,0,1-1.38,4.7,29.82,29.82,0,0,1-10.08,1.74c-24.33,0-30.13-7-30.13-30.13V104.31a30.18,30.18,0,0,1,2-10.79,30.09,30.09,0,0,1,40.21,27.87C262.61,121.56,262.61,121.74,262.61,121.91Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M270,106.85v-6.61L261.93,92l10.84-15s36.43-14.73,20,35.84l-8,3.57A10.49,10.49,0,0,1,270,106.85Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M282,111.51v23.93a13.16,13.16,0,0,1-4.27-2.83,13.39,13.39,0,0,1,2.6-21.1l.38-.21v.21Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#e07591"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M300.46,118.16a13.4,13.4,0,0,1-13.39,13.39,12.08,12.08,0,0,1-1.71-.11,13.39,13.39,0,0,1,0-26.57,13.77,13.77,0,0,1,1.71-.11A13.4,13.4,0,0,1,300.46,118.16Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M297,118.16a13.4,13.4,0,0,1-11.67,13.28,13.39,13.39,0,0,1,0-26.57A13.4,13.4,0,0,1,297,118.16Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M293.07,118.16a6,6,0,1,1-6-6A6,6,0,0,1,293.07,118.16Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#e07591"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 213.82,
    cy: 96.59,
    rx: 10.08,
    ry: 13,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 218.93,
    cy: 97.1,
    rx: 2.41,
    ry: 4.66,
    fill: "#2b2b2b"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M237.06,109.1c-8.73,7-9.15,18.05-9.15,18.05l8.76.57",
    transform: "translate(-11.29 -16.66)",
    fill: "#de315e"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 242.67,
    cy: 96.59,
    rx: 10.08,
    ry: 13,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 223.37,
    y1: 92.9,
    x2: 233.12,
    y2: 92.9,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M279.48,77.74,259.77,90c-20.65-12.73-35.93-1.78-35.93-1.78C217,52.65,274.07,29.73,279.48,77.74Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M237.37,132l8.09-1.24S243.23,140.44,237.37,132Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.66 133.04 246.03 151.12 255.5 181.62 275.78 148.51 270.66 133.04",
    fill: "#ff6665"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M258.16,113.76c0,2.57-1.08,4.65-2.42,4.65s-2.41-2.08-2.41-4.65,1.08-4.66,2.41-4.66S258.16,111.19,258.16,113.76Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M248.36,96.17c2.34-4.83,9.8-8.49,17.14,3Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M217.52,97.44c1.18-5.24,7.6-10.51,17.37-1Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M316.73,264.66a78.09,78.09,0,0,1-9.81,15.5l-33.25,53.06H229.08a15.86,15.86,0,0,1-15.75-14L208,275.85l83-19.24Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#487081"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "198.01 247.89 194.54 179.41 173.63 240.49 198.01 247.89",
    fill: "#487081"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 298.61,
    y1: 90.66,
    x2: 311.38,
    y2: 87.08,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 298.08,
    y1: 98.55,
    x2: 308.7,
    y2: 98.55,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M142.4,192.71l7.11-24.91-34.47,2c-3.72,17.74,10.37,26.85,10.37,26.85Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M143.48,153.77l-13,3.17-1.1-12.7-.76-8.8-9.5-11.51a4.14,4.14,0,0,1,.06-5.32h0a4.12,4.12,0,0,1,6.07-.19l13.36,13.66,3.76,16.82Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.11 127.58 131.1 132.25 130.1 127.75 117.8 124.08 118.11 127.58",
    fill: "#e07591"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M137.74,145.85l-11-3.31h0a4.52,4.52,0,0,0-5.29-1.89l-3,1a4.52,4.52,0,0,0-3,4.81l.12,1-4.26,4.18a3.75,3.75,0,0,0-.58,4.62h0l-1.24,1.93a7.13,7.13,0,0,0-.45,6.9l2.37,5a6,6,0,0,0,6.73,3.26l25.88-6Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "94.99 129.59 109.74 158.27 108.13 159.08 94.1 130.03 94.99 129.59",
    fill: "#e07591"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.55 123.42 115.23 157.49 114.3 157.85 100.53 124.2 102.55 123.42",
    fill: "#e07591"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.52 150.46 115.74 129.53 129.02 135.41 119.52 150.46",
    fill: "#e07591"
  }))), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M149.51,167.8l-.74-14.87a8.52,8.52,0,0,0-7.3-8L128.1,143a2.75,2.75,0,0,0-3.11,3.16h0a8.81,8.81,0,0,0,6.78,7.21l2.8.63s-15,10.56-8.79,28.62Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M124.41,142.45l.5,3.14a9.6,9.6,0,0,0,7.4,7.88l2.26.51S119.76,164,125.78,182.6c-9.51-15.21,2.61-27.5,2.61-27.5h0a7.75,7.75,0,0,1-4.09-7Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#e07591"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "131.11 176.05 137.27 201.98 117.8 214.82 110.84 173.15 131.11 176.05",
    fill: "#edaebe"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "132.19 180.61 112.42 182.6 113.29 187.78 132.19 180.61",
    fill: "#e07591"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "140.04 201.46 135.35 179.41 106.52 190.35 114 215.89 140.04 201.46",
    fill: "#ff6665"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "106.52 190.35 135.35 179.41 140.04 201.46",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M188.87,280l-39.54-72.37-28.64,19.38s6.09,36.68,30.64,82.67Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#538397"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M342.4,341.2l-4.7,2.27L313,355.41s-25.39-150.06-26-152.42c-.51-1.87-.12-24.44.07-33.79.05-2.47.08-4,.08-4C362.84,182.6,342.4,341.2,342.4,341.2Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#538397"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "301.67 338.74 329.68 312.93 331.1 324.54 301.67 338.74",
    fill: "#5f9daf"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M342.4,341.2l-4.7,2.27c11-140.65-33.3-168.69-50.71-174.27.05-2.47.08-4,.08-4C362.84,182.6,342.4,341.2,342.4,341.2Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#5f9daf"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M218.57,221.26c-8.59-11.49-45.47-1.47-45.47-1.47l-4,4.78Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M220.38,221.59C217.53,210.08,249.14,194,249.14,194l9.05,2.38Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "200.72 204.41 157.42 206.57 155.5 208.43 202.42 209.63 200.72 204.41",
    fill: "#2b2b2b"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "200.72 204.41 212.55 201.98 213.81 204.62 200.9 207.06 200.72 204.41",
    fill: "#2b2b2b"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "247.1 176.77 212.55 201.98 213.24 204.65 249.62 177.3 247.1 176.77",
    fill: "#2b2b2b"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "200.9 207.06 155.5 208.43 173.94 280.14 220.22 277.04 200.9 207.06",
    fill: "#2b2b2b"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "231.69 276.36 220.22 277.04 208.37 234.14 206.94 228.97 205.72 224.5 204.22 219.06 200.9 207.06 213.24 204.65 216.19 216.11 217.8 222.35 218.67 225.72 220.34 232.25 231.69 276.36",
    fill: "#ffbf63"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "217.8 222.35 205.72 224.5 204.22 219.06 216.19 216.11 217.8 222.35",
    fill: "#fff"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "220.34 232.25 208.37 234.14 206.94 228.97 218.67 225.72 220.34 232.25",
    fill: "#fff"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "249.62 177.3 213.24 204.65 231.69 276.37 268.94 247.28 249.62 177.3",
    fill: "#ffbf63"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "249.62 177.3 268.94 247.28 236.44 272.65",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.57 247.25 227.9 268.23 215.55 247.89 208.9 251.75 214.63 272.49 234.58 270.83 237.19 255.86 233.57 247.25",
    fill: "#2b2b2b"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.29 216.99 248.68 198.75 251.09 208.17 225.71 226.38 223.29 216.99",
    fill: "#fff"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 231.3,
    y1: 276.63,
    x2: 213.24,
    y2: 204.65,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M250.88,304.43l2.22-25.36-1.4-13a3.46,3.46,0,0,0-4.47-2.93h0a3.45,3.45,0,0,0-2.42,3.22L244.6,276l-2.22,8.12Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M253.49,302.58l-7.62-19.42L218,299.45C225,316.13,238,313.35,238,313.35Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M245.87,283.17,236.63,291l-.37-.61L230,280.11v0l-4.39-10.16-11.53-10a2.56,2.56,0,0,1-.77-2.72h0a2.57,2.57,0,0,1,3.83-1.39l14.48,9.25,11.16,14.16Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M238.25,288l-2,2.34-5.89,6.92-2.56-3.14-5.46-6.75L222,287,221,285.72l-7.18-10.62-8-11.79a2.65,2.65,0,0,1,0-3l.08-.12a2.65,2.65,0,0,1,4.07-.35l10.62,10.77,8.39,8.5,1,.95,4.68,4.53Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M230.46,290.93l-1.38,3.26-1.16,17.26-23-15-5.62-9.21a3,3,0,0,1,.68-3.85,2.93,2.93,0,0,1,2.73-.52,3,3,0,0,1,1.5,1l4.92,6.55,6,3.38-7-7.51-6.5-12.23a2.66,2.66,0,0,1,.32-2.94,2.61,2.61,0,0,1,2.22-.94,2.64,2.64,0,0,1,1.82.92l7.5,8.83,10.38,6.65Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#f5cad7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M206,271.19l7.51,8.82-5.38,6.37-6.49-12.23a2.64,2.64,0,0,1,.32-2.94h0A2.65,2.65,0,0,1,206,271.19Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M205.93,260.2a2.65,2.65,0,0,1,4.07-.35l10.62,10.77-.42.06-6.41,4.42-8-11.79a2.65,2.65,0,0,1,0-3Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M231.62,265.09l-6,4.82-11.53-10a2.56,2.56,0,0,1-.77-2.72h0a2.57,2.57,0,0,1,3.83-1.39Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M209.08,290.51l-4.21,6-5.62-9.21a3,3,0,0,1,.68-3.85,2.93,2.93,0,0,1,2.73-.52,3,3,0,0,1,1.5,1Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#edaebe"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.84 280.64 258.41 290.96 244.55 309.16 225.71 296.73 238.84 280.64",
    fill: "#f5cad7"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.62 302.78 246.9 284.89 258.41 290.96 240.24 308.21 233.62 302.78",
    fill: "#da5565"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    points: "232.48 305.95 252.44 283.62 266.76 288 249.62 319.94 232.48 305.95",
    fill: "#ff6665"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.05 287.77 293.93 293.06 278.96 204.93 270.05 287.77",
    fill: "#487081"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "245.63 323.54 264.79 279.03 311.38 288.88 301.67 338.74 245.63 323.54",
    fill: "#538397"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    points: "264.79 279.03 311.38 288.88 310.57 293.06 261.61 286.42 264.79 279.03",
    fill: "#5f9daf"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "232.48 305.95 252.44 283.62 261.61 286.42",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M170.53,67a1.58,1.58,0,0,1,1.58,1.58v.64a1.58,1.58,0,0,1-1.58,1.58h-.65a1.58,1.58,0,0,1-1.58-1.58v-.64A1.58,1.58,0,0,1,169.88,67h.65m0-1h-.65a2.58,2.58,0,0,0-2.58,2.58v.64a2.58,2.58,0,0,0,2.58,2.58h.65a2.58,2.58,0,0,0,2.58-2.58v-.64A2.58,2.58,0,0,0,170.53,66Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M181,67a1.58,1.58,0,0,1,1.58,1.58v.64A1.58,1.58,0,0,1,181,70.75h-.64a1.57,1.57,0,0,1-1.58-1.58v-.64A1.58,1.58,0,0,1,180.38,67H181m0-1h-.64a2.57,2.57,0,0,0-2.58,2.58v.64a2.57,2.57,0,0,0,2.58,2.58H181a2.57,2.57,0,0,0,2.58-2.58v-.64A2.57,2.57,0,0,0,181,66Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M191.51,67a1.59,1.59,0,0,1,1.59,1.58v.64a1.58,1.58,0,0,1-1.59,1.58h-.64a1.58,1.58,0,0,1-1.58-1.58v-.64A1.58,1.58,0,0,1,190.87,67h.64m0-1h-.64a2.57,2.57,0,0,0-2.58,2.58v.64a2.57,2.57,0,0,0,2.58,2.58h.64a2.58,2.58,0,0,0,2.59-2.58v-.64A2.58,2.58,0,0,0,191.51,66Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M170.53,77.28a1.58,1.58,0,0,1,1.58,1.58v.65a1.58,1.58,0,0,1-1.58,1.58h-.65a1.58,1.58,0,0,1-1.58-1.58v-.65a1.58,1.58,0,0,1,1.58-1.58h.65m0-1h-.65a2.59,2.59,0,0,0-2.58,2.58v.65a2.59,2.59,0,0,0,2.58,2.58h.65a2.59,2.59,0,0,0,2.58-2.58v-.65a2.59,2.59,0,0,0-2.58-2.58Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M181,77.28a1.58,1.58,0,0,1,1.58,1.58v.65A1.58,1.58,0,0,1,181,81.09h-.64a1.58,1.58,0,0,1-1.58-1.58v-.65a1.58,1.58,0,0,1,1.58-1.58H181m0-1h-.64a2.58,2.58,0,0,0-2.58,2.58v.65a2.58,2.58,0,0,0,2.58,2.58H181a2.58,2.58,0,0,0,2.58-2.58v-.65A2.58,2.58,0,0,0,181,76.28Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M191.51,77.28a1.59,1.59,0,0,1,1.59,1.58v.65a1.59,1.59,0,0,1-1.59,1.58h-.64a1.58,1.58,0,0,1-1.58-1.58v-.65a1.58,1.58,0,0,1,1.58-1.58h.64m0-1h-.64a2.58,2.58,0,0,0-2.58,2.58v.65a2.58,2.58,0,0,0,2.58,2.58h.64a2.59,2.59,0,0,0,2.59-2.58v-.65a2.59,2.59,0,0,0-2.59-2.58Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M170.53,87.61a1.59,1.59,0,0,1,1.58,1.59v.64a1.58,1.58,0,0,1-1.58,1.58h-.65a1.58,1.58,0,0,1-1.58-1.58V89.2a1.59,1.59,0,0,1,1.58-1.59h.65m0-1h-.65a2.59,2.59,0,0,0-2.58,2.59v.64a2.58,2.58,0,0,0,2.58,2.58h.65a2.58,2.58,0,0,0,2.58-2.58V89.2a2.59,2.59,0,0,0-2.58-2.59Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M181,87.61a1.59,1.59,0,0,1,1.58,1.59v.64A1.58,1.58,0,0,1,181,91.42h-.64a1.58,1.58,0,0,1-1.58-1.58V89.2a1.58,1.58,0,0,1,1.58-1.59H181m0-1h-.64a2.58,2.58,0,0,0-2.58,2.59v.64a2.57,2.57,0,0,0,2.58,2.58H181a2.57,2.57,0,0,0,2.58-2.58V89.2A2.58,2.58,0,0,0,181,86.61Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M191.51,87.61a1.59,1.59,0,0,1,1.59,1.59v.64a1.59,1.59,0,0,1-1.59,1.58h-.64a1.58,1.58,0,0,1-1.58-1.58V89.2a1.59,1.59,0,0,1,1.58-1.59h.64m0-1h-.64a2.58,2.58,0,0,0-2.58,2.59v.64a2.57,2.57,0,0,0,2.58,2.58h.64a2.58,2.58,0,0,0,2.59-2.58V89.2a2.59,2.59,0,0,0-2.59-2.59Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M170.53,101.84a1.58,1.58,0,0,1,1.58,1.58v.64a1.58,1.58,0,0,1-1.58,1.58h-.65a1.58,1.58,0,0,1-1.58-1.58v-.64a1.58,1.58,0,0,1,1.58-1.58h.65m0-1h-.65a2.58,2.58,0,0,0-2.58,2.58v.64a2.58,2.58,0,0,0,2.58,2.58h.65a2.58,2.58,0,0,0,2.58-2.58v-.64a2.58,2.58,0,0,0-2.58-2.58Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M181,101.84a1.58,1.58,0,0,1,1.58,1.58v.64a1.58,1.58,0,0,1-1.58,1.58h-.64a1.58,1.58,0,0,1-1.58-1.58v-.64a1.57,1.57,0,0,1,1.58-1.58H181m0-1h-.64a2.57,2.57,0,0,0-2.58,2.58v.64a2.57,2.57,0,0,0,2.58,2.58H181a2.57,2.57,0,0,0,2.58-2.58v-.64a2.57,2.57,0,0,0-2.58-2.58Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M191.51,101.84a1.58,1.58,0,0,1,1.59,1.58v.64a1.59,1.59,0,0,1-1.59,1.58h-.64a1.58,1.58,0,0,1-1.58-1.58v-.64a1.58,1.58,0,0,1,1.58-1.58h.64m0-1h-.64a2.57,2.57,0,0,0-2.58,2.58v.64a2.57,2.57,0,0,0,2.58,2.58h.64a2.58,2.58,0,0,0,2.59-2.58v-.64a2.58,2.58,0,0,0-2.59-2.58Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#2b2b2b"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 154.68,
    y1: 80.21,
    x2: 183.71,
    y2: 80.21,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M137.35,48.1l1.77-4.5h2.65L139,49.85l4.47,6h-2.84l-2.92-4.23-1.81,4.23h-2.65L136.07,50l-4.52-6.37h2.84Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M145.81,48.62h3.13l-.42-3h2.23l.42,3h3.17l.3,2.16h-3.17l.42,3.06h-2.22l-.43-3.06h-3.13Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M165,55.84h-2.56l-.69-5-4.9-7.29h2.84l3,4.88,1.64-4.88h2.84l-2.85,7.29Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M170.91,46.76h8.23l.31,2.18h-8.24Zm.52,3.74h8.23l.31,2.18h-8.24Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M188.86,49.67c-1.18,1-1.21,1.31-1.14,1.81l.08.56h-2a2.93,2.93,0,0,1-.8-1.64c-.07-.46.22-.91,1.1-1.69,1.22-1.06,1.37-1.33,1.27-2s-.48-1.07-1.72-1.07a15.11,15.11,0,0,0-2.63.29l-.38-1.81a9.1,9.1,0,0,1,3.06-.63c2.67,0,3.93.88,4.22,3C190.16,48.08,190,48.73,188.86,49.67Zm-3.31,3.38h2.67l.4,2.9H186Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M363.81,16.66H305.68a11.5,11.5,0,0,0-11.5,11.5V67.92l12.71-9.48h56.92a11.5,11.5,0,0,0,11.5-11.5V28.16A11.5,11.5,0,0,0,363.81,16.66Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ffbf63"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 308.7,
    cy: 21.55,
    r: 4.08,
    fill: "#fff"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.03,
    cy: 21.55,
    r: 4.08,
    fill: "#fff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M354.73,38.21a4.08,4.08,0,1,1-4.07-4.08A4.08,4.08,0,0,1,354.73,38.21Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M74.87,104.06,98.69,117.2a3.71,3.71,0,0,1,.4,6.37L76.52,137.86a3.84,3.84,0,0,1-5.78-3.15l-1.25-27.43A3.56,3.56,0,0,1,74.87,104.06Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ff6665"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M154.15,169.42a7.74,7.74,0,0,1-2.67.47H19a6.73,6.73,0,0,1-6.88-6.8l-.37-71.68,0-7.44v-.63a8.6,8.6,0,0,1,8.43-8.43H152.61a6.87,6.87,0,0,1,1.72.21,6.69,6.69,0,0,1,5.16,6.6V84l0,7.44.37,70.06A8.62,8.62,0,0,1,154.15,169.42Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff",
    opacity: 0.3
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M154.15,169.42a7.74,7.74,0,0,1-2.67.47h-.64v-9.62L151,74.91h1.57a6.87,6.87,0,0,1,1.72.21l-.17,85.15v9.15Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "135.93 153.24 128.03 153.24 128.04 146.27 128.05 143.62 128.22 58.26 136.12 58.26 135.95 143.62 135.94 146.27 135.93 153.24",
    fill: "#fff"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M154.15,169.42a7.74,7.74,0,0,1-2.67.47H19a6.73,6.73,0,0,1-6.88-6.8l-.37-71.68,0-7.44v-.63a8.6,8.6,0,0,1,8.43-8.43H152.61a6.87,6.87,0,0,1,1.72.21,6.69,6.69,0,0,1,5.16,6.6V84l0,7.44.37,70.06A8.62,8.62,0,0,1,154.15,169.42Z",
    transform: "translate(-11.29 -16.66)",
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    points: "7.77 146.27 144.65 146.27 144.75 143.62 7.87 143.62 7.77 146.27",
    fill: "#fff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M35.08,162.93h-16l.1-2.66H34.73a4,4,0,0,0-.08.78A4,4,0,0,0,35.08,162.93Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ff6665"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M43.08,161.05a4.33,4.33,0,0,1-.44,1.88,4.26,4.26,0,0,1-3.8,2.34,4.17,4.17,0,0,1-3.76-2.34,4,4,0,0,1-.43-1.88,4,4,0,0,1,.08-.78,4.22,4.22,0,0,1,8.29,0A4,4,0,0,1,43.08,161.05Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#fff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5,161.05a1.64,1.64,0,1,1-1.63-1.63A1.64,1.64,0,0,1,40.5,161.05Z",
    transform: "translate(-11.29 -16.66)",
    fill: "#ff6665"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScene3);
export default __webpack_public_path__ + "static/media/scene-3.ba16d1228f7bc9311fcdcc65471f02bf.svg";
export { ForwardRef as ReactComponent };